// extracted by mini-css-extract-plugin
export default {"gridWrapper":"CompaniesGrid_gridWrapper__6I4bp","companyItemWrap":"CompaniesGrid_companyItemWrap__radfa"};